import { toast } from "react-toastify";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import { LOGIN, LOGOUT, REG_LOADER } from "../types";
import { updateContact } from "./UserActions";
let Auth = RepositoryFactory.get("auth");
let Subscribe = RepositoryFactory.get("subscribe");

export const login =
  (payload, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    dispatch(authLoader(true));
    try {
      const response = await Auth.userLogin(payload);
      const { data } = response;
      if (data?.success) {
        localStorage.setItem("token", JSON.stringify(data.data.token));
        localStorage.setItem("authUser", JSON.stringify(data.data));
        dispatch({
          type: LOGIN,
          payload: { id: data.data.id, ...data.data },
        });
        onSuccess();
        dispatch(authLoader(false));
      }
    } catch (error) {
      dispatch(authLoader(false));
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error.message ||
          "Something Went Wrong"
      );
      console.log(error);
      onError(error.response.data.message);
    } finally {
      dispatch(authLoader(false));
    }
  };

export const registerUser =
  (payload, subscriptionPayload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const { email, password } = payload;
      const { data } = await Auth.registerUser(payload);
      const userId = data?.data?.id;

      if (subscriptionPayload) {
        subscriptionPayload.userId = userId;

        // Login before subscribing.
        // NOTE: ship this change before adding protect to live backend
        await dispatch(login({ email, password }));

        // login() swallows its own failures — it toasts and calls
        // onError rather than rethrowing — so the token is the only
        // trustworthy signal that it worked. Subscribing without one
        // would 401 once the route is protected, and the customer
        // would have an account and no plan with nothing said about it.
        if (!localStorage.getItem("token")) {
          throw new Error(
            "We created your account but couldn't sign you in, so your plan was not started. Please sign in and choose your plan again."
          );
        }

        await Subscribe.subscribePlan(subscriptionPayload);

        /*
            RE-READ THE USER ROW. SUBSCRIBING JUST CHANGED IT.

            login() above is the only thing that writes the cached user, and
            it ran before the Stripe customer existed, so the cached copy has
            stripe_customer_id = null. subscribePlan has now written both
            stripe_customer_id and api_plan on the server.

            Nothing else refreshes it: the whole authUser slice is encrypted
            into localStorage and rehydrated on every reload (store/index.js),
            and there is no GET /user/me, so without this the stale copy
            survives indefinitely. Setting.js then short-circuits on the
            missing id, never asks for the subscription, shows the hardcoded
            "Sample Course" block, and hides the only link to cancelling
            (Dave, on dev and prod, 2026-09-18).

            This mirrors the already-signed-in upgrade path, which has done
            the same thing since it was written — see updatePlan in
            subscribeAction.js. PUT /user/update-contact with {} is
            allowlist-filtered to a no-op server-side and returns the fresh
            row.
        */
        await dispatch(updateContact({}));
      }

      onSuccess();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error?.message ||
          "Something Went Wrong"
      );
      // if (error.response) {
      //     toast.error(error.response.data.message);
      // }
      dispatch(registerLoader(false));
    }
  };

export const forgetPassword =
  (email, onSuccess = () => {}) =>
  async (dispatch) => {
    console.log("forgetPassword");

    dispatch(authLoader(true));

    try {
      let payload = {
        email,
      };
      const response = await Auth.forgetPassword(payload);
      const { data } = response;
      if (data.success) {
        onSuccess();
        dispatch(authLoader(false));
      }
    } catch (error) {
      dispatch(authLoader(false));
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error.message ||
          "Something Went Wrong"
      );
      console.error(error.message);
    } finally {
      dispatch(authLoader(false));
    }
  };

export const resetPassword =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(authLoader(true));
    try {
      // console.log({ payload });
      const response = await Auth.resetPassword(payload);
      const { data } = response;
      if (data.success) {
        onSuccess();
        dispatch(authLoader(false));
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.data?.message ||
          error.message ||
          "Something Went Wrong"
      );
      dispatch(authLoader(false));
      console.error(error.message);
    } finally {
      dispatch(authLoader(false));
    }
  };

export const logout =
  (onSuccess = () => {}) =>
  async (dispatch) => {
    // console.log("reach");
    dispatch({
      type: LOGOUT,
    });
    onSuccess();
  };

export const authLoader = (val) => async (dispatch) => {
  dispatch({ type: "AUTH_LAODER", payload: val });
};
export const registerLoader = (val) => async (dispatch) => {
  dispatch({ type: REG_LOADER, payload: val });
};
